import Swiper from 'swiper';
export const init = async function() {
    new Swiper('.js-instagram', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 13,
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
                centeredSlides: false
            }
        }
    });
};
